import React from 'react'
import PropTypes from 'prop-types'
import ChatConversationsListView from '../component/ChatConversationsListView'
import ChatConversationItem from '../../ChatConversationItem/container/ChatConversationItem'
import Button from '@material-ui/core/Button'

const ChatConversationsList = ({
  conversations,
  onConversationClick,
  onConversationArchive,
  activeConversationId,
  onRefresh,
  isLoadingConversations,
  loadMoreComponent,
}) => {
  if (conversations.length < 1 && !isLoadingConversations) {
    return (
      <ChatConversationsListView>
        <Button variant="contained" onClick={onRefresh}>
          Try Again
        </Button>
      </ChatConversationsListView>
    )
  }
  return (
    <ChatConversationsListView isLoading={isLoadingConversations}>
      {conversations.map(conversation => (
        <ChatConversationItem
          key={conversation.id}
          id={conversation.id}
          name={conversation.name}
          lastMessageText={conversation.lastMessageText}
          lastMessageTime={conversation.timestamp}
          onConversationClick={() =>
            onConversationClick({
              id: conversation.id,
              name: conversation.name,
            })
          }
          onConversationArchive={e => {
            e.stopPropagation()
            onConversationArchive(conversation.id)
          }}
          isActive={activeConversationId === conversation.id}
          isCityBased={conversation.isCityBased}
          isUnread={conversation.isUnread}
          archived={conversation.archived}
        />
      ))}
      {loadMoreComponent}
    </ChatConversationsListView>
  )
}

ChatConversationsList.propTypes = {
  conversations: PropTypes.array,
  onConversationClick: PropTypes.func,
  onConversationArchive: PropTypes.func,
  activeConversationId: PropTypes.number,
}

export default ChatConversationsList
